export default __webpack_public_path__ + "static/media/DensoWaveGreen.94b2a340.svg";